import React, { useEffect, useState, useMemo, useRef, useCallback } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import Card from 'ui/components/Card';
import InsentLink from 'ui/components/InsentLink';
import MessageContainer from 'ui/components/MessageContainer';
import * as globalActions from 'ui/containers/App/actions';
import * as globalSelectors from 'ui/containers/App/selectors';
import DOMPurify from 'dompurify';
import {
  useFileUploadProgress,
  useFileErrorHandler,
  getFilesFromUppyState,
  uploadFilesToTransloadit
} from "../../../utils/uppy";
import ProgressBar from "../../components/ProgressBar";
import {ReactComponent as AllFiles} from 'assets/icons/allfiles.svg';
import FileItem from "../../components/FileItem";
import AttachmentError from "../../components/AttachmentError";
import moment from "moment";
import { useConfig } from 'context';
import {
  ConversationHeader,
  ConversationDetailContainer,
  ConversationDetail,
  ConversationWrapper,
  ConversationList,
  ConversationBackIcon,
  ConversationBackButton,
  TypingIndicator,
  NewMessageDot,
  NotificationContainer,
  AZoomInfoCompany,
  AgentHeader,
  AgentTitle,
  AgentLinkedinIcon,
  AgentName,
  HeaderDropdown,
  AgentSenderMessageWrapper,
  ConversationHeaderDetail,
  HeaderDetailListItem,
  HeaderDetailHead,
  HeaderDetailCloseIcon,
  LinkIframe,
  LinkIframeHeader,
  LinkIframeCloseButton,
  LinkBackButton,
  LinkBackIcon,
  LinkFrameLoading,
  AllFilesHeader,
  AllFilesHeaderText,
  AllFilesCloseButton,
  AllFilesListContainer,
  AllFilesFooter, NoFilesFoundDiv, LoadingWrapper,
} from './common';
import {PAGE, MOMENT_STRINGS, CALENDAR_STRINGS, MOMENT_TIME_LIMIT} from 'common/constants';
import PageLoader from 'ui/components/Loaders/PageLoader';
import theme from 'styles/theme';
import NativeNotification from 'ui/components/NativeNotification';
import {
  MESSAGE_TYPES,
  SENDING_MESSAGE_TYPE,
  NATIVE_NOTIFICATION_VARIANT,
  WINDOW_POSTMESSAGE_TYPES,
  TRIGGER_EVENT_TYPES,
} from '../App/constants';
import downArrow from 'assets/icons/downArrow.svg';
import closeBlackButton from 'assets/icons/closeBlackButton.svg';
import backIcon from 'assets/icons/back.svg';
import AllFilesCloseIcon from 'assets/icons/close-all-files.svg';
import AllFilesBackIcon from 'assets/icons/back-all-files.svg';
import linkedinIcon from 'assets/icons/linkedin.svg';
import Avatar from 'react-avatar';
import MessageInput from 'ui/components/MessageInput';
import { BOT } from './constants';
import { eventTypes } from 'utils/eventTypes';
import MoreOptions from "../../components/MoreOptions";
import {
  mergePathEventsAndEvents,
  saveEventToLocalStorage,
  saveToLocalStorage,
  getFromLocalStorage,
  deleteFromLocalStorage,
} from 'utils/saveToLocalStorage';
import localStorageTemplates from 'common/local-storage-templates';
import InsentAvatar from 'ui/components/Avatar';
import * as selectors from "../App/selectors";
import * as actions from "../App/actions";
import {hideRestartButton} from "ui/containers/App/actions";
import Moment from "react-moment";
import styled from "styled-components";
import {slideUp} from "../../../styles/animation";
import { postMessageToWindow } from 'utils/index';
import { cloneDeep } from 'lodash';
moment.updateLocale('en', {calendar: MOMENT_STRINGS});

// Disclaimer component
const DISCLAIMER_HEIGHT = 49; // Approximate height including padding and borders

const DisclaimerContainer = styled.div`
  border-top: 1px solid #e9ecef;
  padding: 12px 16px;
  font-size: 12px;
  color: #6c757d;
  line-height: 1.4;
  text-align: center;
  position: relative;
  z-index: 1;
  box-shadow: 0 5px 15px 0 rgba(80,80,80,0.1);
  background: #ffffff;
  @media (max-width: 768px) {
    max-width: 600px;
  }

  @media (max-width: 480px) {
    max-width: 340px;
    width: 100%;
  }
`;

DOMPurify.addHook('afterSanitizeAttributes', function(node) {
  // set all elements owning target to target=_blank
  if ('target' in node) {
    node.setAttribute('target', '_blank');
    // prevent https://www.owasp.org/index.php/Reverse_Tabnabbing
    node.setAttribute('rel', 'noopener noreferrer');
  }
  return node;
});


let activePathData = { index: 0, response: {}, active: false };
const Conversation = props => {
  const {
    userData,
    Language,
    userSettings,
    userSettingColor,
    userConversation,
    greetingMessageAction,
    conversationMessages,
    pushMessage,
    hideRemovableElements,
    setActivePageStart,
    conversationLoading,
    currentChannel,
    getUserConversation,
    getAllFiles,
    clearUserConversation,
    sendDataToServer,
    showNewMessageNotification,
    setSendGreetingMessageAction,
    userConfig,
    nativeNotification,
    pushSendingMessage,
    setDelayFlag,
    sendingMessages,
    clearActiveUserMessages,
    setNativeNotification,
    setNotificationRead,
    textAreaNumberOfLines,
    setTextAreaNumberOfLinesStart,
    clearBotActivePath,
    clearBotActivePathStart,
    setShowTyping,
    showTyping,
    networkDelay,
    resetNetworkDelay,
    iframePage,
    hideIframeLoader,
    closeLinkIframe,
    fetchMeetingSlotsStart,
    bookMeetingSlot,
    isPusherConnected,
    shouldHideRestartButton,
    handleSendingMessageToPusher,
    removeFromConversation,
    userAttachments,
    customCookies,
  } = props;
  const { config } = useConfig();
  const messagesEndRef = useRef(null);
  const conversationListRef = useRef();
  const currentPathTimestamp = useRef(0);
  const conversationHeaderRef = useRef(null);

  const scrollToBottom = () => {
    if (messagesEndRef && messagesEndRef.current) {
      messagesEndRef.current.scrollIntoView();
    }
  };

  const [headerData, setHeaderData] = useState({
    title: userSettings && typeof userSettings !== "undefined" ? (userSettings.bot ? userSettings.bot.company : '') : '',
    subtitle: Language && Language.YouAreChattingWith && Language.YouAreChattingWith.toString().replace("{members}", userSettings && typeof userSettings !== "undefined" ? (userSettings.bot ? userSettings.bot.company : '') : ''),
    members: [{ name: userSettings && typeof userSettings !== "undefined" ? (userSettings.bot ? userSettings.bot.company : '') : '', img: userSettings ? (userSettings.bot ? userSettings.bot.img : '') : '', isBot: true }],
  });

  const [headerHeight, setHeaderHeight] = useState(80);

  const [showInputBox, setShowInputBox] = useState(false);
  const [showAttachFiles, setShowAttachFiles] = useState(false);
  const [showRestartConversation, setShowRestartConversation] = useState(true);
  const [isServiceCloud, setIsServiceCloud] = useState(false);
  const [displayAllFiles, setDisplayAllFiles] = useState(false);

  const [showHeaderDetail, setShowHeaderDetail] = useState(false);

  const [lastBotTriggered, setLastBotTriggered] = useState(Date.now() - BOT.DELAY);

  const [greetingMessageActionKey, setGreetingMessageActionKey] = useState(null);
  const [conversationHeaderHeight, setConversationHeaderHeight] = useState(null);

  const [progressBarCompletion, setProgressBarCompletion] = useState(0);

  const [uploadErrorMessage, setUploadErrorMessage] = useState('');

  const [previewRetry, setPreviewRetry] = useState(false);

  let progress = useFileUploadProgress();
  useFileErrorHandler(setUploadErrorMessage, setProgressBarCompletion, setPreviewRetry);
  useEffect(() => {
    activePathData = { index: 0, response: {}, active: false };
  }, [clearBotActivePath]);

  window.insentClearActivePathData = clearBotActivePath;

  useEffect(() => {
    if(conversationHeaderRef?.current) resizeObserver.observe(conversationHeaderRef?.current);
  }, [conversationHeaderRef.current, displayAllFiles])

  useEffect(() => {
    setShowRestartConversation(!shouldHideRestartButton);
  }, [shouldHideRestartButton])

  useEffect(() => {
    const { eventListenerName } = userConfig;
    if(getFromLocalStorage(localStorageTemplates.widgetSessionActive) === 'true')
    {
      if(customCookies && Array.isArray(customCookies) && customCookies.length >0) {
        postMessageToWindow(
            {
              type: eventListenerName,
              event: WINDOW_POSTMESSAGE_TYPES.getCustomCookies,
              customCookies,
            },
            '*'
        );
      }
    }
  }, [])

  useEffect(() => {
    setProgressBarCompletion(progress);
  }, [progress])

  useEffect(() => {
    if (userConversation && userConversation.input !== undefined) {
      setShowInputBox(userConversation.input);
    }
    if (userConversation.botActive) {
      setHeaderData({
        title: userSettings && typeof userSettings !== "undefined" ? (userSettings.bot ? userSettings.bot.company : '') : '',
        subtitle: Language && Language.YouAreChattingWith && Language.YouAreChattingWith.toString().replace("{members}",userSettings && typeof userSettings !== "undefined" ? (userSettings.bot ? userSettings.bot.name : '') : ''),
        members: [{ name: userSettings && typeof userSettings !== "undefined" ? (userSettings.bot ? userSettings.bot.company : '') : '' , img: userSettings ? (userSettings.bot ? userSettings.bot.img : '') : '', isBot: true }],
      });
    } else {
      setShowAttachFiles(true);
      activePathData = { index: 0, response: {}, active: false };

      if (userConversation && userConversation.members && userConversation.members.length > 0) {
        let subtitle = Language && Language.YouAreChattingWith && Language.YouAreChattingWith.toString().replace("{members}",userConversation.members[0].name);
        if (userConversation.members.length > 1) {
          subtitle = Language && Language.YouAreChattingWithAndOthers.toString().replace("{members}", userConversation.members[0].name).replace("{numbers}", userConversation.members.length - 1);
        }
        setHeaderData({ ...headerData, members: userConversation.members, subtitle });
      } else {
        setHeaderData({
          title: userSettings && typeof userSettings !== "undefined" ? (userSettings.bot ? userSettings.bot.company : '') : '',
          subtitle: Language && Language.YouAreChattingWith && Language.YouAreChattingWith.toString().replace("{members}", userSettings && typeof userSettings !== "undefined" ? (userSettings.bot ? userSettings.bot.name : '') : ''),
          members: [{ name: userSettings && typeof userSettings !== "undefined" ? (userSettings.bot ? userSettings.bot.company : '') : '', img: userSettings && typeof userSettings !== "undefined" ? (userSettings.bot ? userSettings.bot.img : '') : '', isBot: true }],
        });
      }
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userConversation.members, userConversation.botActive, userConversation.input]);

  useEffect(() => {
    if (currentChannel) {
      getUserConversation({ meta: { cid: currentChannel } });
    }
    return () => {
      activePathData = { index: 0, response: {}, active: false };

      clearUserConversation();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentChannel]);

  useEffect(() => {
    if(!isPusherConnected) return;
    if (userConversation && userConversation.messages && userConversation.messages.length) {
      activePathData = { index: 0, response: {}, active: false };

      currentPathTimestamp.current = userConversation.messages[0].timestamp;
      processUserConversation();
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userConversation.messages, isPusherConnected]);

  useEffect(() => {
    setTimeout(scrollToBottom, 0);
  }, [conversationMessages, showTyping, sendingMessages, showInputBox, isServiceCloud, userSettings, displayAllFiles]);

  useEffect(()=>{
      if(displayAllFiles){
        let meta = {}
        getAllFiles({ meta: { cid: currentChannel } });
      }
  }, [displayAllFiles])

  useEffect(() => {
    const event = {
      eventType: eventTypes.CONVERSATION_PAGE_LOADED,
      timestamp: Date.now(),
      url: userConfig.blogUrl,
      props: {
        channelId: currentChannel,
      },
    };
    saveEventToLocalStorage(event);
    return () => {
      setTextAreaNumberOfLinesStart(1);
      clearBotActivePathStart(false);
    };
  }, []);

  useEffect(() => {
    if(Object.keys(greetingMessageAction).length === 0 || !greetingMessageAction || !isPusherConnected.current || showTyping || conversationLoading) return;
    let pathResponse = cloneDeep(greetingMessageAction.response);
    let pathMessage = cloneDeep(greetingMessageAction.message);
    if(conversationMessages && Array.isArray(conversationMessages) && conversationMessages.length > 0 && conversationMessages[conversationMessages.length - 1].key !== pathMessage.key) return;
      pathResponse.lastMessageTimeStamp = userConversation.messageTimestamp;
    pathMessage.time = Date.now();
    dispatchMessage({ payload: pathMessage });
    sendResponseToServer({ response: pathResponse, botMessage: true, message: pathMessage});
    hideRemovableElements({});
    setGreetingMessageActionKey(pathMessage.key);
    setSendGreetingMessageAction({});

  }, [greetingMessageAction, showTyping, sendingMessages, isPusherConnected, conversationLoading, conversationMessages])

  const sendResponseToServer = metadata => {
    let { response, botMessage, message } = metadata;
    if (response) {
      if (response.feedback) {
        const { userId } = userConfig;
        let data = {
          type: SENDING_MESSAGE_TYPE.bot,
          data: { channelName: currentChannel, feedback: response.feedback, senderId: userId, display: message },
        };
        sendDataToServer(data);
      } else if (response.calendar) {
        const { userId } = userConfig;
        let data = {
          type: SENDING_MESSAGE_TYPE.bot,
          data: { channelName: currentChannel, calendar: response.calendar, senderId: userId, display: message },
          isCalendarCancel: true,
        };
        sendDataToServer(data);
      } else if (botMessage) {
        if(message && message.input)
        {
          const updatedInput = {
            ...message.input, 
            value: message.input.key,
            disabled: true,
          };
          message = { ...message, input: updatedInput };
        }
        const { userId } = userConfig;
        let data = {
          type: SENDING_MESSAGE_TYPE.bot,
          data: { senderId: userId, channelName: currentChannel, message: response, display: message },
        };
        sendDataToServer(data);
      }
      else if(response.attachments && (!Array.isArray(response.attachments) || response.attachments.length > 0)){
        let newMessage = message;
        if(!newMessage){
          newMessage = {
            img: null,
            name: null,
            lead: true,
            attachments: response.attachments,
            time: Date.now(),
            type: MESSAGE_TYPES.attachments,
          }
        }
        setProgressBarCompletion(90);
        sendDataToServer({
          type: SENDING_MESSAGE_TYPE.message,
          data: { display: newMessage }
        });
      }
      else if(response.gif){
        let newMessage = message;
        if(!newMessage){
          newMessage = {
            img: null,
            name: null,
            lead: true,
            gif: response.gif,
            time: Date.now(),
            type: MESSAGE_TYPES.gif,
          }
        }
        sendDataToServer({
          type: SENDING_MESSAGE_TYPE.message,
          data: { display: newMessage }
        });
      }
      else {
        let newMessage = message;
        if(!newMessage)
        {
          newMessage = {
            img: null,
            name: null,
            lead: true,
            text: response.text,
            time: Date.now(),
            type: MESSAGE_TYPES.text,
          };
        }
        sendDataToServer({
          type: SENDING_MESSAGE_TYPE.message,
          data: { display: newMessage }
        });
      }
      activePathData = { index: 0, response: {}, active: false };
    }
  };

  const processUserConversation = async (prevMessageResponse) => {
    let index = activePathData.index || 0;
    let payload = {};
    let end = false;
    let isShowMessage = true;

    activePathData.active = false;
    if (!userConversation.messages) {
      return;
    }
    for (index; index < userConversation.messages.length; index++) {
      const item = userConversation.messages[index];
      payload = {};
      payload.img = userConversation.sender ? userConversation.sender.img || null : null;
      payload.name = userConversation.sender ? userConversation.sender.name || 'Agent' : 'Agent';
      payload.lastMessageTimeStamp = userConversation.messageTimestamp || item?.timestamp;
      payload.lead = false;
      payload.time = Date.now();
      payload.type = item?.type;
      payload.stepUid = item?.stepUid;
      payload.userId = userConversation.sender ? userConversation.sender.id || null : null;
      isShowMessage = true;
      if (item?.pause && item?.pause > 0) {
        setShowTyping(true);
        setDelayFlag({time: Date.now()+item?.pause, counter: 0});
        await sleep(item?.pause);
        setDelayFlag(false);
        setShowTyping(false);
      }

      if(window.insentLastNonBotMessageTime > userConversation.messageTimestamp){
        isShowMessage = false;
        break;
      }

      if (
        activePathData.botNotification ||
        (nativeNotification && nativeNotification.message && nativeNotification.botNotification)
      ) {
        setNativeNotification({
          variant: NATIVE_NOTIFICATION_VARIANT.success,
          message: null,
        });
        activePathData.botNotification = false;
      }
      setShowInputBox(false);
      setIsServiceCloud(false);
      switch (item?.type) {
        case MESSAGE_TYPES.text:
          payload.text = item?.text;
          payload.mentions = item?.mentions;
          activePathData.index = index + 1;
          payload.category = item?.category;
          payload.keyValues = item?.keyValues;
          saveEventToLocalStorage({
            eventType: eventTypes.PLAIN_MESSAGE_SHOWN,
            timestamp: Date.now(),
            url: userConfig.blogUrl,
            props: {
              channelId: currentChannel,
              text: item?.text,
              stepUid: item?.stepUid,
            },
          });
          break;
        case MESSAGE_TYPES.attachments:
          payload.attachments = item?.attachments;
          activePathData.index = index + 1;
          break;
        case MESSAGE_TYPES.notification:
          activePathData.botNotification = true;
          activePathData.index = index + 1;
          isShowMessage = false;
          activePathData.botNotification = false;

          break;
        case MESSAGE_TYPES.buttons:
          payload.buttons = item?.buttons?.fields;
          payload.key = item?.buttons?.key;
          activePathData.key = item?.buttons?.key;
          activePathData.index = index + 1;
          activePathData.active = true;
          payload.stepUid = item?.stepUid || item?.buttons?.stepUid;
          end = true;
          saveEventToLocalStorage({
            eventType: eventTypes.BUTTONS_SHOWN,
            timestamp: Date.now(),
            url: userConfig.blogUrl,
            props: {
              channelId: currentChannel,
              stepUid: item?.stepUid ? item?.stepUid : item?.buttons?.stepUid,
            },
          });

          break;
        case MESSAGE_TYPES.gif:
          payload.gif = item?.gif;
          payload.key = item?.gif?.key;
          payload.type = MESSAGE_TYPES.gif;
          activePathData.key = item?.gif?.key;
          activePathData.index = index + 1;
          activePathData.active = true;
          payload.stepUid = item?.stepUid || item?.gif?.stepUid;
          saveEventToLocalStorage({
            eventType: eventTypes.BUTTONS_SHOWN,
            timestamp: Date.now(),
            url: userConfig.blogUrl,
            props: {
              channelId: currentChannel,
              stepUid: item?.stepUid ? item?.stepUid : item?.buttons?.stepUid,
            },
          });
          break;
        case MESSAGE_TYPES.link:
          payload.link = item?.link;
          activePathData.index = index + 1;
          saveEventToLocalStorage({
            eventType: eventTypes.CALENDAR_LINK_SHOWN,
            timestamp: Date.now(),
            url: userConfig.blogUrl,
            props: {
              channelId: currentChannel,
              link: item?.link && item?.link.url,
              stepUid: item?.stepUid,
            },
          });

          break;
        case MESSAGE_TYPES.event:
          payload.event = item?.event;
          activePathData.index = index + 1;
          payload.category = item?.category;
          payload.keyValues = item?.keyValues;
          break;
        case MESSAGE_TYPES.input.val:
          const inputIndex = activePathData.inputIndex || 0;

          const inputDetail = item?.input[inputIndex];
          let input = {};
          input.key = inputDetail.key;
          input.uid = inputDetail.uid;
          if (inputDetail.type === MESSAGE_TYPES.input.email) {
            input.type = MESSAGE_TYPES.input.email;
            activePathData.key = inputDetail.key;
            activePathData.active = true;
            input.text = inputDetail.name;
            input.blockedDomains = item?.blockedDomains;
            input.validateDomains = inputDetail.validateDomains;
            end = true;
            payload.input = input;
          } else if(inputDetail.fieldType === MESSAGE_TYPES.input.picklist){
            input.type = MESSAGE_TYPES.input.picklist;
            activePathData.key = inputDetail.key;
            activePathData.active = true;
            input.text = inputDetail.name;
            input.picklistValues = inputDetail.picklistValues;
            end = true;
            payload.input = input;
          } else if (inputDetail.type === MESSAGE_TYPES.input.plain) {
            input.type = MESSAGE_TYPES.input.plain;
            activePathData.key = inputDetail.key;
            activePathData.active = true;
            input.text = inputDetail.name;
            input.fieldType = inputDetail.fieldType;
            end = true;
            payload.input = input;
          }

          if (inputIndex < item?.input?.length - 1) {
            activePathData.inputIndex = inputIndex + 1;
            activePathData.index = index;
          } else {
            activePathData.inputIndex = 0;
            activePathData.index = index + 1;
          }
          saveEventToLocalStorage({
            eventType: eventTypes.USER_DATA_FIELD_SHOWN,
            timestamp: Date.now(),
            url: userConfig.blogUrl,
            props: {
              channelId: currentChannel,
              field: inputDetail.name.toLowerCase(),
              stepUid: item?.stepUid,
              uid: inputDetail.uid || item.uid,
            },
          });
          break;
        case MESSAGE_TYPES.plainInput:
          activePathData.key = item?.plainInput?.key;
          activePathData.index = index + 1;
          activePathData.active = true;
          activePathData.stepUid = item?.stepUid;
          end = true;
          saveEventToLocalStorage({
            eventType: eventTypes.PLAIN_INPUT_SHOWN,
            timestamp: Date.now(),
            url: userConfig.blogUrl,
            props: {
              channelId: currentChannel,
              field: item?.plainInput?.key,
              stepUid: item?.stepUid,
            },
          });
          setShowInputBox(item?.plainInput?.fieldType === "number" ? "number" : true);
          isShowMessage = false;
          break;
        case MESSAGE_TYPES.zendeskCreateTicket:
          activePathData.key = item?.zendeskCreateTicket?.key;
          activePathData.index = index + 1;
          activePathData.active = true;
          activePathData.zendeskType = eventTypes.ZENDESK_CREATE_TICKET_INPUT_PROVIDED;
          activePathData.stepUid = item?.stepUid;
          end = true;
          saveEventToLocalStorage({
            eventType: eventTypes.ZENDESK_CREATE_TICKET_INPUT_SHOWN,
            timestamp: Date.now(),
            url: userConfig.blogUrl,
            props: {
              channelId: currentChannel,
              field: item?.zendeskCreateTicket?.key,
              stepUid: item?.stepUid,
            },
          });
          setShowInputBox(true);
          isShowMessage = false;
          break;
        case MESSAGE_TYPES.zendeskSearchKnowledgeBase:
          activePathData.key = item?.zendeskSearchKnowledgeBase?.key;
          activePathData.index = index + 1;
          activePathData.active = true;
          activePathData.zendeskType = eventTypes.ZENDESK_SEARCH_KNOWLEDGEBASE_INPUT_PROVIDED;
          activePathData.stepUid = item?.stepUid;
          end = true;
          saveEventToLocalStorage({
            eventType: eventTypes.ZENDESK_SEARCH_KNOWLEDGEBASE_INPUT_SHOWN,
            timestamp: Date.now(),
            url: userConfig.blogUrl,
            props: {
              channelId: currentChannel,
              field: item?.zendeskSearchKnowledgeBase?.key,
              stepUid: item?.stepUid,
            },
          });
          setShowInputBox(true);
          isShowMessage = false;
          break;
        case MESSAGE_TYPES.serviceCloudCreateTicket:
          activePathData.key = item?.serviceCloudCreateTicket?.key;
          activePathData.index = index + 1;
          activePathData.active = true;
          activePathData.serviceCloudType = eventTypes.SERVICE_CLOUD_CREATE_TICKET_INPUT_PROVIDED;
          activePathData.stepUid = item?.stepUid;
          end = true;
          saveEventToLocalStorage({
            eventType: eventTypes.SERVICE_CLOUD_CREATE_TICKET_INPUT_SHOWN,
            timestamp: Date.now(),
            url: userConfig.blogUrl,
            props: {
              channelId: currentChannel,
              field: item?.serviceCloudCreateTicket?.key,
              stepUid: item?.stepUid,
            },
          });
          setShowInputBox(true);
          isShowMessage = false;
          break;
        case MESSAGE_TYPES.serviceCloudKnowledgeBase:
          activePathData.key = item?.serviceCloudKnowledgeBase?.key;
          activePathData.index = index + 1;
          activePathData.active = true;
          activePathData.serviceCloudType = eventTypes.SERVICE_CLOUD_SEARCH_KNOWLEDGEBASE_INPUT_PROVIDED;
          activePathData.stepUid = item?.stepUid;
          end = true;
          saveEventToLocalStorage({
            eventType: eventTypes.SERVICE_CLOUD_SEARCH_KNOWLEDGEBASE_INPUT_SHOWN,
            timestamp: Date.now(),
            url: userConfig.blogUrl,
            props: {
              channelId: currentChannel,
              field: item?.serviceCloudKnowledgeBase?.key,
              stepUid: item?.stepUid,
            },
          });
          setShowInputBox(true);
          setIsServiceCloud(true);
          isShowMessage = false;
          break;
        case MESSAGE_TYPES.feedback:
          payload.feedback = item?.feedback;
          activePathData.key = item?.feedback?.key;
          activePathData.index = index + 1;
          activePathData.active = true;
          end = true;
          break;
        case MESSAGE_TYPES.calendar:
          payload.calendar = item?.calendar;
          payload.stepUid = item?.stepUid;
          payload.calendar = { ...payload.calendar, validateDomains: item?.validateDomains };
          activePathData.key = item?.calendar?.key;
          activePathData.index = index + 1;
          activePathData.active = true;
          end = true;
          break;
        default:
          break;
      }
      if (isShowMessage && !prevMessageResponse) {
        dispatchMessage({ payload });
      }
      else if (!prevMessageResponse){
        hideRemovableElements({});
      }

      if (end){
        break;
    }
    }
    if (!prevMessageResponse && index >= userConversation.messages.length) {
      let pathResponse = activePathData.response;
      let pathMessage = activePathData.message;
      pathResponse.lastMessageTimeStamp = userConversation.messageTimestamp ;
      if (Object.keys(pathResponse).length) {
        sendResponseToServer({ response: pathResponse, botMessage: true, message: pathMessage});
        mergePathEventsAndEvents();
      } else {
        if (!userConversation.end) {
          sendResponseToServer({ response: { lastMessageTimeStamp : userConversation.messageTimestamp }, botMessage: true });
        }
      }
      clearActiveUserMessages();
      return;
    }
  };

  const dispatchMessage = ({ payload }) => {
    pushMessage({ meta: { message: payload } });
  };

  const handleHyperLinkRedirects = (button) => {
    if(button && typeof button === "object" && button.hyperlink){
      const { eventListenerName } = userConfig;
      let buttonMessage = {
        hyperlink: button.hyperlink,
        newTab: !!button.newTab
      }
      postMessageToWindow(
          {
            type: eventListenerName,
            event: WINDOW_POSTMESSAGE_TYPES.hyperlinkRedirect,
            eventData: buttonMessage
          },
          '*'
      );
    }
  }

  const processUserResponse = (response, type, message, uid) => {
    let prevMessageResponse = false;
    const { eventListenerName } = userConfig;
    activePathData.response[activePathData.key || type] = response;
    activePathData.message = message;
    activePathData.stepUid = message.stepUid;
    switch (type) {
      case MESSAGE_TYPES.feedback: {
        if (message.feedback._id) message._id = message.feedback._id;
        if (message.cancelled) {
          message.type = MESSAGE_TYPES.event;
          message.event = Language ? Language.FeedbackCanceled : 'Feedback Canceled';
          message.time = Date.now();
          message.lead = false;
          delete message.cancelled;
        }
        message.feedback = { ...message.feedback, ...response };
        dispatchMessage({ payload: message });
        if (!message.isCancellable && message._id) {
          prevMessageResponse = true;
          let processedResponse = {lastMessageTimeStamp: userConversation.messageTimestamp};
          processedResponse.feedback = {
            ...response,
            messageId: message._id,
          };
          sendResponseToServer({ response: processedResponse, botMessage: true, message });
        }
        break;
      }
      case MESSAGE_TYPES.calendar: {
        message.calendar = { ...message.calendar, ...response };
        dispatchMessage({ payload: message });
        if (message._id || (!message.isNewCalendar)) {

          prevMessageResponse = true;
          activePathData.response[type] = response;
          let processedResponse = {lastMessageTimeStamp: userConversation.messageTimestamp};
          processedResponse.calendar = {
            ...response,
            messageId: message._id || message.calendar.messageId,
          };
          sendResponseToServer({ response: processedResponse, botMessage: true, message });
        }
        break;
      }
      case MESSAGE_TYPES.buttons: {
        message.text = response.toString();
        message.type = MESSAGE_TYPES.text;
        message.lead = true;
        message.name = null;
        delete message.buttons;
        postMessageToWindow(
            {
              type: eventListenerName,
              event: WINDOW_POSTMESSAGE_TYPES.triggerEvent,
              eventType: TRIGGER_EVENT_TYPES.buttonClicked,
              eventData: message
            },
            '*'
        );
        dispatchMessage({ payload: message });
        saveEventToLocalStorage({
          eventType: eventTypes.BUTTON_CLICKED,
          timestamp: Date.now(),
          url: userConfig.blogUrl,
          props: {
            channelId: currentChannel,
            buttonText: message.text,
            uid: uid,
            stepUid: message.stepUid,
          },
        });
        break;
      }
      case MESSAGE_TYPES.input.plain:
      {
        let msgObj = { ...message, input: { ...message.input } };
        msgObj.input.disabled = true;
        msgObj.input.value = response;
        dispatchMessage({ payload: msgObj });
        saveEventToLocalStorage({
          eventType: eventTypes.USER_DATA_PROVIDED,
          timestamp: Date.now(),
          url: userConfig.blogUrl,
          props: {
            channelId: currentChannel,
            field: message.input.text.toLowerCase(),
            uid: uid,
            stepUid: message.stepUid,
          },
        });
        break;
      }
      case MESSAGE_TYPES.input.picklist:
      {
        let msgObj = { ...message, input: { ...message.input } };
        msgObj.input.disabled = true;
        msgObj.input.value = response.label;
        dispatchMessage({ payload: msgObj });
        saveEventToLocalStorage({
          eventType: eventTypes.USER_DATA_PROVIDED,
          timestamp: Date.now(),
          url: userConfig.blogUrl,
          props: {
            channelId: currentChannel,
            field: message.input.text.toLowerCase(),
            uid: uid,
            stepUid: message.stepUid,
          },
        });
        break;
      }
      case MESSAGE_TYPES.input.email: {
        let msgObj = { ...message, input: { ...message.input } };
        msgObj.input.disabled = true;
        msgObj.input.value = response;
        postMessageToWindow(
            {
              type: eventListenerName,
              event: WINDOW_POSTMESSAGE_TYPES.triggerEvent,
              eventType: TRIGGER_EVENT_TYPES.emailCapture,
              eventData: msgObj
            },
            '*'
        );
        dispatchMessage({ payload: msgObj });
        saveEventToLocalStorage({
          eventType: eventTypes.USER_DATA_PROVIDED,
          timestamp: Date.now(),
          url: userConfig.blogUrl,
          props: {
            channelId: currentChannel,
            field: message.input.text.toLowerCase(),
            uid: uid,
            stepUid: message.stepUid,
          },
        });
        break;
      }
      case MESSAGE_TYPES.input.phone: {
        let msgObj = { ...message, input: { ...message.input } };
        msgObj.input.disabled = true;
        msgObj.input.value = response;
        postMessageToWindow(
            {
              type: eventListenerName,
              event: WINDOW_POSTMESSAGE_TYPES.triggerEvent,
              eventType: TRIGGER_EVENT_TYPES.phoneNumberCapture,
              eventData: msgObj
            },
            '*'
        );
        dispatchMessage({ payload: msgObj });
        saveEventToLocalStorage({
          eventType: eventTypes.USER_DATA_PROVIDED,
          timestamp: Date.now(),
          url: userConfig.blogUrl,
          props: {
            channelId: currentChannel,
            field: message.input.text.toLowerCase(),
            uid: uid,
            stepUid: message.stepUid,
          },
        });
        break;
      }
      default:
        break;
    }
    processUserConversation(prevMessageResponse);
  };

  const triggerBot = () => {
    setTextAreaNumberOfLinesStart(1);
    resetNetworkDelay();
    clearBotActivePathStart(false);
    saveEventToLocalStorage({
      eventType: eventTypes.TRIGGER_BOT_CLICKED,
      timestamp: Date.now(),
      url: userConfig.blogUrl,
      props: {
        channelId: currentChannel,
      },
    });
    const response = `@${userConfig.botName}`;
    const message = {
      img: null,
      name: null,
      lead: true,
      text: response,
      time: Date.now(),
      type: MESSAGE_TYPES.text,
    };
    if (Date.now() - lastBotTriggered > BOT.DELAY) {
      setLastBotTriggered(Date.now());
      activePathData.active = false;

      pushSendingMessage({ meta: { message } });
      sendResponseToServer({ response: { lastMessageTimeStamp:userConversation.messageTimestamp, text: response }, botMessage: false, message: message });
      setShowInputBox(false);
      activePathData = { index: 0, response: {}, active: false };
    }
  };

  const handleUserResponse = e => {
    e.preventDefault();
    const response = e.target.message.value;
    const clean = DOMPurify.sanitize(response, { ALLOWED_TAGS: [] });
    if (clean !== response) {
          return;
    }

    saveEventToLocalStorage({
      eventType: activePathData.zendeskType || activePathData.serviceCloudType || eventTypes.PLAIN_INPUT_PROVIDED,
      timestamp: Date.now(),
      url: userConfig.blogUrl,
      props: {
        channelId: currentChannel,
        field: activePathData.key,
        stepUid: activePathData.stepUid,
      },
    });
    
    if (response && response.trim().length > 0) {
      const message = {
        img: null,
        name: null,
        lead: true,
        text: response,
        time: Date.now(),
        type: MESSAGE_TYPES.text,
      };

      if (activePathData.active && userConversation.input === false) {
        dispatchMessage({ payload: message });
        setShowInputBox(userConversation.input);
        processUserResponse(response, MESSAGE_TYPES.plainInput, message);
      } else {
        pushSendingMessage({ meta: { message } });
        sendResponseToServer({ response: { lastMessageTimeStamp: userConversation.messageTimestamp, text: response }, botMessage: false });
      }
    }
  };

  const onClickRetry = () => {
    setUploadErrorMessage('');
    setPreviewRetry(false);
    const allFiles = getFilesFromUppyState();
    const handleAllFilesAttachment  = (meta) => {
      handleFileAttachment(meta, allFiles[0].meta.fileId);
      if(allFiles.length>1){
        for(let i=1; i<allFiles.length; i++){
          removeFromConversation({id: allFiles[i].meta.fileId})
        }
      }
    }
    uploadFilesToTransloadit({sendToPusher: handleAllFilesAttachment}, config, setProgressBarCompletion, setUploadErrorMessage, setPreviewRetry);
  }

  const handleFileAttachment = (e, id = null) => {
    const message = {
      img: null,
      name: null,
      lead: true,
      attachments: e.attachments,
      time: Date.now(),
      type: MESSAGE_TYPES.attachments,
      id,
      setProgressBarCompletion
    };
    pushSendingMessage({ meta: { message } });
    sendResponseToServer({ response: { lastMessageTimeStamp: userConversation.messageTimestamp, attachments: e.attachments }, botMessage: false });
  }

  const handleGifAttachment = (e, id= null) => {
    const event = {
      eventType: eventTypes.GIF_SENT,
      timestamp: Date.now(),
      url: userConfig.blogUrl,
      props: {
        channelId: currentChannel,
        gif: e.gif,
        uid: activePathData.uid,
        stepUid: activePathData.stepUid,
      },
    };
    saveEventToLocalStorage(event);
    const message = {
      img: null,
      name: null,
      lead: true,
      gif: e.gif,
      time: Date.now(),
      type: MESSAGE_TYPES.attachments,
      id,
      setProgressBarCompletion
    };
    pushSendingMessage({ meta: { message } });
    sendResponseToServer({ response: { lastMessageTimeStamp: userConversation.messageTimestamp, gif: [e.gif]}, botMessage: false });

  }

  const renderConversationHeader = useMemo(() => {
    if (!headerData) return;
    let name;
    if (headerData.members && headerData.members.length > 0) {
      if (headerData.members.length <= 2) {
        name = headerData.members[0].name;
        if (headerData.members.length > 1) {
          name += ` & ${headerData.members[1].name}`;
        }
      } else {
        name = `${headerData.members[0].name} & ${headerData.members.length - 1} others`;
      }
    }
    return (
      <ConversationHeader ref={conversationHeaderRef}>
        {showHeaderDetail && (
          <ConversationHeaderDetail>
            <HeaderDetailHead>
              <ConversationBackButton onClick={() => setActivePageStart(PAGE.HOME)}>
                <ConversationBackIcon src={backIcon} alt="back button" />
              </ConversationBackButton>
              {Language.PeopleInThisConversation}
              <HeaderDetailCloseIcon
                src={closeBlackButton}
                onClick={() => setShowHeaderDetail(false)}
              />
            </HeaderDetailHead>          
            {headerData.members &&
              headerData.members.map(member => (
                <HeaderDetailListItem>
                  <InsentAvatar size="50" img={member.img} name={member.name} />
                  <AgentSenderMessageWrapper>
                    <AgentHeader>
                      <AgentName>
                        {DOMPurify.sanitize(member.name)}
                        {member?.linkedinUrl && (
                          <div
                            dangerouslySetInnerHTML={{__html: DOMPurify.sanitize(`
                            <a href="${member?.linkedinUrl}" target="_blank" rel="noopener noreferrer">
                            <img style="margin-left: 0.25rem; height: 16px; width:16px;"
                              src=${linkedinIcon}
                              alt="linkedin"
                            />
                          </a>
                          `)}}
                          />
                        )}
                      </AgentName>
                    </AgentHeader>
                    <AgentTitle>{DOMPurify.sanitize(member.title || '')||''}</AgentTitle>
                  </AgentSenderMessageWrapper>
                </HeaderDetailListItem>
              ))}
          </ConversationHeaderDetail>
        )}
        <ConversationBackButton onClick={() => setActivePageStart(PAGE.HOME)}>
          {showNewMessageNotification && (
            <NewMessageDot
              headerTextColor={userSettingColor ? userSettingColor.headerTextColor : null}
            ></NewMessageDot>
          )}
          <ConversationBackIcon src={backIcon} alt="back button" />
        </ConversationBackButton>
        {headerData.members && headerData.members.length > 0 ? (
          headerData.members.map((member, memberIndex) => (
            <React.Fragment key={memberIndex}>
              {memberIndex < 2 && (
                <InsentAvatar
                  bgColor={userSettingColor ? userSettingColor.headerBackgroundColor : theme.palette.primary}
                  zIndex={memberIndex}
                  marginLeft={memberIndex === 0 ? '0' : `-${29 + (memberIndex - 1) * 5}px`}
                  size={member.isBot ? '40px' : '50'}
                  img={member.img}
                  name={member.name}
                  isBot={member.isBot}
                />
              )}
            </React.Fragment>
          ))
        ) : (
          <InsentAvatar
            bgColor={userSettingColor ? userSettingColor.headerBackgroundColor : theme.palette.primary}
            size="40"
            img={userSettings.bot.img}
            name={userSettings.bot.name || 'Bot'}
            isBot={true}
          />
        )}
        <AgentSenderMessageWrapper>
          <AgentHeader>
            <AgentName data-toggle="tooltip" title={name}>
              {DOMPurify.sanitize(name)}
            </AgentName>
            {headerData.members.length > 1 ? (
              <HeaderDropdown src={downArrow} onClick={() => setShowHeaderDetail(true)} />
            ) : (
              headerData?.members[0]?.linkedinUrl && (
                <div
                  dangerouslySetInnerHTML={{__html:
                        DOMPurify.sanitize(`<a
                            href="${headerData?.members[0]?.linkedinUrl}"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                          <img style="margin-left: 0.25rem;height: 16px;width:16px;" src="${linkedinIcon}" alt="linkedin" />
                        </a>`)
                  }}
                />
              )
            )}
          </AgentHeader>
          {headerData.members.length === 1 && headerData.members[0].title && (
            <AgentTitle>{DOMPurify.sanitize(headerData.members[0].title) || ''}</AgentTitle>
          )}
          <AgentTitle>{DOMPurify.sanitize(headerData.subtitle) || ''}</AgentTitle>
        </AgentSenderMessageWrapper>
        <MoreOptions
            Language={Language}
            setDisplayAllFiles={setDisplayAllFiles}
            triggerBot={triggerBot}
            disableFileSharing={userSettings.disableFileSharing}
            shouldShowRestartConversation={true}
            userSettingColor={userSettingColor}
            showInputBox={showInputBox}
        />
      </ConversationHeader>
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [headerData, showNewMessageNotification, showHeaderDetail, displayAllFiles]);

  const renderConversation = useMemo(() => {
    return (!conversationLoading && isPusherConnected) ? (
      <ConversationWrapper  id="insent-conversation-wrapper">
        <ConversationList ref={conversationListRef} id="insent-conversation-list">
          {typeof conversationMessages.map === "function" && conversationMessages.map((message, index) => {
            if(message.key === greetingMessageActionKey && message.type === "buttons") return;
            let prevMessage = null;
            if (index > 0) prevMessage = conversationMessages[index - 1];
            message = {...message, channelId: currentChannel };
            return (
              <div key={index}>
                <MessageContainer
                  id={`insent-message-container-${index}`}
                  prevMessage={prevMessage}
                  message={{ ...message }}
                  processUserResponse={processUserResponse}
                  userSettingColor={userSettingColor}
                  userSettings={userSettings}
                  Language={Language}
                  previewRetry={previewRetry}
                  onClickRetry={onClickRetry}
                  setPreviewRetry={setPreviewRetry}
                  item={{
                    itemIndex: index,
                    total: conversationMessages.length + sendingMessages.length,
                  }}
                  handleHyperLinkRedirects={handleHyperLinkRedirects}
                  userConfig={userConfig}
                  currentChannel={currentChannel}
                  fetchMeetingSlots={fetchMeetingSlotsStart}
                  bookMeetingSlot={bookMeetingSlot}
                  conversationListRef={conversationListRef}
                  messageKey={index}
                />
              </div>
            );
          })}
          {typeof sendingMessages.map === "function" && sendingMessages.map((message, index) => {
            let prevMessage = null;
            if (index === 0) prevMessage = conversationMessages[conversationMessages.length - 1];
            else if (index > 0) prevMessage = sendingMessages[index - 1];

            return (
              <div key={index + conversationMessages.length}>
                <MessageContainer
                  id={`insent-message-container-${index+conversationMessages.length}`}
                  prevMessage={prevMessage}
                  message={{ ...message }}
                  processUserResponse={processUserResponse}
                  userSettingColor={userSettingColor}
                  userSettings={userSettings}
                  item={{
                    itemIndex: index + conversationMessages.length,
                    total: conversationMessages.length + sendingMessages.length,
                  }}
                  handleHyperLinkRedirects={handleHyperLinkRedirects}
                  onClickRetry={onClickRetry}
                  previewRetry={previewRetry}
                  setPreviewRetry={setPreviewRetry}
                  sending={true}
                  userConfig={userConfig}
                  currentChannel={currentChannel}
                  key={index + conversationMessages.length}
                />
              </div>
            );
          })}

          {showTyping && (
            <TypingIndicator
              id="insent-typing-indicator"
              color={userSettingColor? userSettingColor.headerBackgroundColor : theme.palette.primary}
            />
          )}
          <div ref={messagesEndRef} />
        </ConversationList>
      </ConversationWrapper>
    ) : (
      <LoadingWrapper>
        <TypingIndicator
          id="insent-typing-indicator"
          color={userSettingColor? userSettingColor.headerBackgroundColor : theme.palette.primary}
          />
      </LoadingWrapper>
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [conversationMessages, showTyping, sendingMessages, showInputBox, isServiceCloud, userSettings, isPusherConnected, previewRetry]);

  const renderInputBox = () => (
      <>
        {showInputBox ? (
          <MessageInput
            id="insent-message-input"
            onSubmit={handleUserResponse}
            Language={Language}
            bgColor={userSettingColor ? userSettingColor.headerBackgroundColor : null}
            textColor={userSettingColor ? userSettingColor.headerTextColor : null}
            placeholder={Language && Language.TypeYourReply}
            type="input"
            fieldType={showInputBox}
            showAttachFiles={(!userSettings.disableFileSharing && userSettings.disableFileSharing !== "false") && (!(userConversation.botActive === undefined || userConversation.botActive))}
            showGif={(!(userConversation.botActive === undefined || userConversation.botActive))}
            isServiceCloud={isServiceCloud}
            handleSendingMessageToPusher={handleFileAttachment}
            handleSendingGifsToPusher={handleGifAttachment}
            removeFromConversation={removeFromConversation}
            pushMessage={pushMessage}
            setProgressBarCompletion={setProgressBarCompletion}
            triggerBot={triggerBot}
            setPreviewRetry={setPreviewRetry}
            botHover={`Chat with ${userSettings && typeof userSettings !== "undefined" ? (userSettings.bot ? userSettings.bot.name : '') : ''}`}
            setTextAreaNumberOfLinesStart={setTextAreaNumberOfLinesStart}
            textAreaNumberOfLines={textAreaNumberOfLines}
            setUploadErrorMessage={setUploadErrorMessage}
          />
        ) : (
          <MessageInput
            id="insent-message-input"
            Language={Language}
            triggerBot={triggerBot}
            bgColor={userSettingColor ? userSettingColor.headerBackgroundColor : null}
            textColor={userSettingColor ? userSettingColor.headerTextColor : null}
            type="button"
            removeFromConversation={removeFromConversation}
            handleSendingMessageToPusher={handleFileAttachment}
            handleSendingGifsToPusher={handleGifAttachment}
            placeholder={`Chat with ${userSettings && typeof userSettings !== "undefined" ? (userSettings.bot ? userSettings.bot.name : '') : ''}`}
            setUploadErrorMessage={setUploadErrorMessage}
            setPreviewRetry={setPreviewRetry}
            setTextAreaNumberOfLinesStart={setTextAreaNumberOfLinesStart}
          />
        )}
      </>
      // eslint-disable-next-line react-hooks/exhaustive-deps
    )

  const sleep = ms => {
    return new Promise(resolve => setTimeout(resolve, ms));
  };

  const conversationCloseAction = () => {
    const event = {
      eventType: eventTypes.CONVERSATION_PAGE_CLOSED,
      timestamp: Date.now(),
      url: userConfig.blogUrl,
      props: {
        channelId: currentChannel,
      },
    };
    setNotificationRead(0);
    saveToLocalStorage(localStorageTemplates.notificationRead, 0);
    saveEventToLocalStorage(event);
    setActivePageStart(PAGE.LAUNCHER);
  };

  const calculateConversationDetailHeight = () => {
    const baseHeight = textAreaNumberOfLines <= 5 ? 110 : 210;
    const headerHeight = conversationHeaderRef.current ? 
      (conversationHeaderRef.current.clientHeight < 80 ? 80 : conversationHeaderRef.current.clientHeight) : 80;
    const textAreaHeight = textAreaNumberOfLines <= 5 ? textAreaNumberOfLines * 20 : 0;
    const restartButtonHeight = showRestartConversation ? 30 : 0;
    return `calc(100vh - ${baseHeight + headerHeight + textAreaHeight + restartButtonHeight + DISCLAIMER_HEIGHT}px)`;
  }

  const getHeaderHeight = () => {
    if(!conversationHeaderRef.current || !conversationHeaderRef.current.clientHeight) return 80;
    return (conversationHeaderRef.current.clientHeight < 80 ? 80: conversationHeaderRef.current.clientHeight)
  }

  const resizeObserver = new ResizeObserver(entries => {
    if(entries.length > 0) setHeaderHeight(entries[0].target.clientHeight);
  })

  const renderEntireConversation = () => {
    return (
        <>
          {renderConversationHeader}
          <DisclaimerContainer id="insent-disclaimer-container">
            By inputting information into this AI chatbot, you agree that we may collect, use, and share your data with certain vendors as described in our Privacy Policy.
          </DisclaimerContainer>
          <ConversationDetailContainer id="insent-conversation-detail-container">
            <ProgressBar Language={Language} percentage={progressBarCompletion}/>
            <AttachmentError message={uploadErrorMessage} setUploadErrorMessage={setUploadErrorMessage}/>
            {nativeNotification && nativeNotification.message && (
                <NotificationContainer id="insent-notification-container">
                  <NativeNotification {...nativeNotification} />
                </NotificationContainer>
            )}
            <ConversationDetail
                id="insent-conversation-detail"
                height={calculateConversationDetailHeight()}
            >
              {iframePage.show ? (
                  <LinkIframe id="insent-link-iframe">
                    <LinkIframeHeader id="insent-link-iframe-header">
                      <LinkIframeCloseButton id="insent-link-iframe-close-button" onClick={closeLinkIframe}>
                        <LinkBackButton id="insent-link-back-button">
                          <LinkBackIcon  id="insent-link-back-icon" src={backIcon} alt="back button" />
                        </LinkBackButton>
                      </LinkIframeCloseButton>
                    </LinkIframeHeader>
                    {iframePage.loading && (
                        <LoadingWrapper  id="insent-link-frame-loading">
                        <TypingIndicator
                          id="insent-typing-indicator"
                          color={userSettingColor? userSettingColor.headerBackgroundColor : theme.palette.primary}
                          />
                        </LoadingWrapper>
                    )}
                    <iframe title="Link Message" onLoad={hideIframeLoader} src={iframePage.link.url} />
                  </LinkIframe>
              ) : (
                  <>{renderConversation}</>
              )}
            </ConversationDetail>
            <>{showRestartConversation && renderInputBox()}</>
          </ConversationDetailContainer>
        </>
    )
  }

const NewSessionTime = styled.div`
  text-align: center;
  font-size: 9px;
  color: #2F3C4E;
  mix-blend-mode: normal;
  opacity: 0.5;
  transform: translateY(10px);
  animation: ${slideUp} 0.2s ease-in-out 0.1s forwards;
  will-change: transform;
  font-style: italic;
  line-height: 11px;
  ${p => p.lead && 'text-align: right; padding-right: 0.25rem'}
  ${p => p.previousMessage && 'margin-top: 16px'}
  margin: 12px 0 8px 0;
  & time{
    opacity: 0.5;
  }
`;

  const renderAllFilesList = () => {
    let userAttachmentsDiv = Array.isArray(userAttachments) && userAttachments.length > 0 ? userAttachments.map((ele, index) => {
      return (
          <>
            {
              (index === 0 || moment(ele.createdAt*1000) === (moment(userAttachments[index-1].createdAt * 1000))) &&
              <NewSessionTime>
                  <Moment calendar={MOMENT_STRINGS} interval={10000} unix>
                    {ele.createdAt > MOMENT_TIME_LIMIT ? ele.createdAt / 1000 : ele.createdAt}
                  </Moment>
               </NewSessionTime>
            }
            <FileItem
                bgColor={userSettingColor ? userSettingColor.headerBackgroundColor : theme.palette.primary}
                attachment={ele}
            />
          </>
          );
        }
    ) : (<NoFilesFoundDiv>{Language.NoFilesShared}</NoFilesFoundDiv>)
    return userAttachmentsDiv;
  }

  const renderAllFiles = () => {
    return (
        <>
          <ConversationHeader>
            <ConversationBackButton onClick={() => setDisplayAllFiles(false)}>
              <ConversationBackIcon src={AllFilesBackIcon} alt="back button" />
            </ConversationBackButton>
            <AllFilesHeader>
              <AllFiles fill={"#000000"}></AllFiles>
              <AllFilesHeaderText>{Language.AllFiles}</AllFilesHeaderText>
            </AllFilesHeader>
          </ConversationHeader>
          <AllFilesListContainer>
            {renderAllFilesList()}
          </AllFilesListContainer>
          <AllFilesFooter bgColor={userSettingColor ? userSettingColor.headerBackgroundColor : null}/>
        </>
    );
  }

  return (
    <>
      <Card id="insent-conversation-card" onClose={conversationCloseAction} hideClose={showHeaderDetail}>
        {!displayAllFiles && renderEntireConversation()}
        {displayAllFiles && renderAllFiles()}
      </Card>
      <InsentLink show={userData?userData.settings?userData.settings.showPoweredByInsentText:true:true} privacyPolicy={userData?.privacyPolicy} />
    </>
  );
};

Conversation.propTypes = {
  userSettings: PropTypes.object,
  userSettingColor: PropTypes.object,
  userConversation: PropTypes.object,
  conversationMessages: PropTypes.array,
  conversationLoading: PropTypes.bool,
  currentChannel: PropTypes.string,
  getUserConversation: PropTypes.func,
  pushMessage: PropTypes.func,
  setActivePageStart: PropTypes.func,
  clearUserConversation: PropTypes.func,
};

export const mapStateToProps = (state, props) => {
  return createStructuredSelector({
    userData: globalSelectors.makeSelectCurrentUser(),
    userSettings: globalSelectors.makeSelectCurrentUserSettings(),
    customCookies: globalSelectors.makeSelectCustomCookies(),
    userSettingColor: globalSelectors.makeSelectCurrentUserSettingColor(),
    userConversation: globalSelectors.makeSelectCurrentUserConversation(),
    conversationMessages: globalSelectors.makeSelectConversationMessages(),
    conversationLoading: globalSelectors.makeSelectConversationLoading(),
    currentChannel: globalSelectors.makeSelectCurrentChannel(),
    userConfig: globalSelectors.makeSelectConfig(),
    Language: globalSelectors.makeSelectLanguage(),
    sendingMessages: globalSelectors.makeSelectSendingMessages(),
    networkStatus: globalSelectors.makeSelectNetworkStatus(),
    textAreaNumberOfLines: globalSelectors.makeSelectTextAreaNumberOfLines(),
    clearBotActivePath: globalSelectors.makeSelectClearBotActivePath(),
    showTyping: globalSelectors.makeSelectIsTyping(),
    networkDelay: globalSelectors.makeSelectNetworkDelay(),
    iframePage: globalSelectors.makeSelectIframePage(),
    shouldHideRestartButton: globalSelectors.makeSelectHideRestartButton(),
    greetingMessageAction: globalSelectors.makeSelectGreetingMessageAction(),
    userAttachments: globalSelectors.makeSelectUserAttachments(),
  });
};

export const mapDispatchToProps = dispatch => {
  return {
    getUserConversation: ({ meta }) => dispatch(globalActions.getUserConversation.start({ meta })),
    getAllFiles: ({meta}) => dispatch(globalActions.getAllFiles.start({meta})),
    pushMessage: ({ meta }) => dispatch(globalActions.updateConversationMessages.start({ meta })),
    pushSendingMessage: ({ meta }) => dispatch(globalActions.updateSendingMessages.start({ meta })),
    setDelayFlag: flag => dispatch(globalActions.setDelayFlag(flag)),
    hideRemovableElements: ({ meta }) => dispatch(globalActions.hideRemovableMessage.start({ meta })),
    setActivePageStart: page => dispatch(globalActions.setActivePage.start(page)),
    clearUserConversation: () => dispatch(globalActions.clearUserConversation()),
    clearActiveUserMessages: () => dispatch(globalActions.clearActiveMessages()),
    setTextAreaNumberOfLinesStart: data => dispatch(globalActions.setTextAreaNumberOfLines(data)),
    clearBotActivePathStart: payload => dispatch(globalActions.clearBotActivePath(payload)),
    setShowTyping: payload => dispatch(globalActions.setShowTyping(payload)),
    resetNetworkDelay: () => dispatch(globalActions.resetNetworkDelay()),
    hideIframeLoader: () => dispatch(globalActions.setLinkIframe.success()),
    removeFromConversation: id => dispatch(globalActions.removeFromConversationMessages.start({ meta: { id } })),
    closeLinkIframe: () => dispatch(globalActions.setLinkIframe.error()),
    fetchMeetingSlotsStart: ({meta}) => dispatch(globalActions.fetchMeetingSlots({meta})),
    bookMeetingSlot: ({meta, payload}) => dispatch(globalActions.bookMeetingSlot({meta, payload})),
    setSendGreetingMessageAction: message => dispatch(globalActions.setSendGreetingMessageAction(message)),
    handleSendingMessageToPusher: ({ meta }) => dispatch(actions.handleSendingMessagesToPusher({ meta })),
  };
};

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default withConnect(Conversation);
